<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Add One-Off Report
      <div class="title-report-info">
        <h1>
          {{
            "In this screen you add One-Off Reports only, e.g. audit reports or retroactive reports. Only one entry in Reporting Tracker will be created."
          }}
        </h1>
        <h1>
          {{
            "If you want to add recurring reports, please open respective customer in Customer Profile and add the report there"
          }}
        </h1>
      </div>
      <b-button slot="right" type="is-primary" @click="routeToReportingTracker">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <reporting-tracker-add></reporting-tracker-add>
    </section>
  </div>
</template>

<script>
import ReportingTrackerAdd from "@/components/Reportingtracker/ReportingTrackerAdd";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";

export default {
  name: "ReportingTrackerAddView",
  components: { HeroBar, TitleBar, ReportingTrackerAdd },
  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    routeToReportingTracker() {
      this.$router.push({
        name: "reportingtracker",
        query: { id: this.$route.params.id }
      });
    }
  },
  computed: {
    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/reportingtracker/add", name: "Add One-Off Reports" }
      ];
    }
  }
};
</script>
